import LoginSP from 'apps/front/pages/auth/LoginSP';
import React from 'react';

function Login() {
  return (<LoginSP></LoginSP>)
}

export default Login;
